import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from './baseQuery';

const TAG_TYPES = ['User', 'Analytics', 'Portal', 'Session'] as const;
export type TagType = (typeof TAG_TYPES)[number];

/**
 * The single RTK Query API slice. Features add endpoints with `baseApi.injectEndpoints`
 * in their own `api/` folder so code-splitting and ownership stay per feature.
 */
export const baseApi = createApi({
  reducerPath: 'api',
  baseQuery,
  tagTypes: TAG_TYPES,
  keepUnusedDataFor: 60,
  refetchOnReconnect: true,
  endpoints: () => ({}),
});

/** Standard tags for a paged list: one per item plus a LIST tag to invalidate on create/delete. */
export function providesList(result: { items: { id: string }[] } | undefined, type: TagType) {
  const listTag = { type, id: 'LIST' };
  return result ? [...result.items.map(({ id }) => ({ type, id })), listTag] : [listTag];
}
